<template>
	<div>
		<div class="container-fluid checkout-main">
			<div class="row">
				<div class="container-fluid checkout-content">
					<div
						class="success_message"
						v-text="this.$root.success_message"
						v-if="this.$root.success_message != ''"
					></div>
					<div
						class="error_message"
						v-text="this.$root.error_message"
						v-if="this.$root.error_message != ''"
					></div>
					<div class="row">
						<div class="col-md-12 col-sm-12 col-xs-12 checkout-section">
							<!--login section start here-->
							<div class="login-section opc-section" id="login-section">
								<h3 class="section-title font-medium">Login</h3>
								<form class="login-form">
									<div
										class="field mobile"
										v-bind:class="{
											success: this.mobile === true,
											error: this.mobile_error != '',
										}"
									>
										<label class="label"><span>Mobile Number</span></label>
										<input
											maxlength="10"
											class="input-text form-control"
											autocomplete="off"
											v-model="mobile_number"
											@keyup="mobile_no"
											name="mobile"
											autofocus
										/>
										<p class="size_error" v-text="mobile_error"></p>
									</div>
									<div
										class="field otp"
										v-bind:class="{
											success: this.otp === true,
											error: this.otp_error != '',
										}"
									>
										<label class="label"
											><span>One Time Password(OTP)</span></label
										>
										<input
											class="input-text form-control"
											maxlength="4"
											type="text"
											name="customerpassword"
											v-model="otp_number"
											:disabled="this.mobile == false"
											autocomplete="off"
											ref="otpLoginComponent"
										/>
										<p class="size_error" v-text="otp_error"></p>
										<label class="timer-main font-medium"
											><span>Please enter the OTP sent on your mobile</span
											><span
												class="timer-container"
												v-if="
													this.mobile === true && this.resend_otp_time != 60
												"
												><span>00:</span
												><span
													class="timer"
													v-text="this.resend_otp_time"
												></span></span
											><a
												href="#"
												class="action otp-resend-button"
												id="resend"
												@click.prevent="resend_otp()"
												v-if="
													this.mobile === true && this.resend_otp_time === 60
												"
												><span>Resend OTP </span></a
											></label
										>
									</div>
								</form>
							</div>
							<!--login section end here-->
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from "axios";
	export default {
		name: "login",
		data() {
			return {
				mobile_number: "",
				mobile_error: "",
				mobile: false,
				otp_number: "",
				otp_error: "",
				otp: false,
				from_path: "",
				resend_otp_time: 60,
			};
		},
		beforeRouteEnter(to, from, next) {
			next((vm) => {
				vm.from_path = from.path;
			});
		},
		methods: {
			countDownTimer() {
				if (this.resend_otp_time > 0) {
					setTimeout(() => {
						this.resend_otp_time -= 1;
						this.countDownTimer();
					}, 1000);
				}
				if (this.resend_otp_time == 0) {
					this.resend_otp_time = 60;
				}
			},
			resend_otp() {
				this.$root.error_message = "";
				this.$root.success_message = "";
				this.resend_otp_time = 60;
				this.countDownTimer();
				var form = new FormData();
				form.append("phone", this.mobile_number);
				let config = { headers: { "Content-Type": "multipart/form-data" } };
				axios
					.post(this.$root.cart_api + "/customer/send-otp", form, config)
					.then((response) => {
						if (response.data.success === true) {
							this.$root.success_message = response.data.message;
							this.$root.error_message = "";
						} else {
							this.$root.error_message = response.data.message;
							this.$root.success_message = "";
						}
					})
					.catch((error) => {
						this.$root.page_loader = false;
						if (error.message === "Network Error") {
							this.$root.error_message =
								"Oops there seems to be some Network issue, please try again.";
						}
						window.scrollTo(0, 0);
					});
			},
			mobile_no: function () {
				this.resend_otp_time = 60;
				var phoneno = /^([0-9]{10,})+$/;
				if (this.mobile_number.match(phoneno)) {
					this.mobile_error = "";
					if (this.mobile_number.length == "10") {
						this.mobile = true;
						this.$root.error_message = "";
						this.$root.success_message = "";
						setTimeout(() => {
							this.$refs.otpLoginComponent.focus();
						}, 0);
						var form = new FormData();
						form.append("phone", this.mobile_number);
						let config = { headers: { "Content-Type": "multipart/form-data" } };
						axios
							.post(this.$root.cart_api + "/customer/send-otp", form, config)
							.then((response) => {
								if (response.data.success === true) {
									this.$root.success_message = response.data.message;
									this.$root.error_message = "";
									this.$gtm.trackEvent({
										event: "Login",
										category: "Login",
										action: "OTP Sent",
									});
								} else {
									this.$root.error_message = response.data.message;
									this.$root.success_message = "";
								}
							})
							.catch((error) => {
								this.$root.page_loader = false;
								if (error.message === "Network Error") {
									this.$root.error_message =
										"Oops there seems to be some Network issue, please try again.";
								}
								window.scrollTo(0, 0);
							});
					} else {
						this.mobile = false;
						this.otp = false;
						this.otp_number = "";
					}
				} else {
					this.mobile = false;
					this.mobile_error = "Please enter valid mobile number";
				}
			},
		},
		created() {
			// window.scrollTo(0, 0);
			//  if(this.$root.customer_id != null && this.$root.customer_id != ''){
			//    this.$router.push('account-dashboard.html')
			//  }
			this.$root.error_message = "";
			this.$root.success_message = "";
			//this.$root.page_loader = false;
		},
		watch: {
			otp_number: {
				handler: function (after, before) {
					var otpno = /^\d*(?:\.\d{1,2})?$/;
					if (this.otp_number.match(otpno)) {
						this.otp_error = "";
						if (this.otp_number.length == "4") {
							this.$root.error_message = "";
							this.$root.success_message = "";
							// this.$root.page_loader = true;
							this.otp = true;
							this.$root.customer_id = "";
							var form = new FormData();
							form.append("phone", this.mobile_number);
							if (this.$root.pcart != null && this.$root.pcart != "") {
								form.append("pcart", this.$root.pcart);
							}
							form.append("store", this.$root.store);
							form.append("otp", this.otp_number);
							axios
								.post(this.$root.cart_api + "/customer/validate-otp", form)
								.then((response) => {
									
									if (response.data.success === true) {
										// this.$root.page_loader = false;
										this.$root.error_message = "";
										this.$root.success_message = response.data.message;
										this.$root.customerDetails.name = response.data.data.customer.full_name;
										this.$root.customerDetails.number = response.data.data.customer.phone;
										
										this.$cookies.set(
											window.location.hostname.substring(10, 4) + "_customer",
											response.data.data.customer.id,
											"1y"
										);
										this.$cookies.set(
											window.location.hostname.substring(10, 4) + "_cs",
											response.data.data.customer_session,
											"1y"
										);
										this.$root.customer_id = response.data.data.customer.id * 1;
										this.$root.customer_session =
											response.data.data.customer_session;
										if (response.data.data.pcart) {
											this.$root.cart_product = response.data.data.products;
											this.$root.pcart = response.data.data.pcart;
											this.$root.thankyou_cart = response.data.data.pcart;
											this.$cookies.set(
												window.location.hostname.substring(10, 4) + "_cart",
												response.data.data.pcart,
												"1y"
											);
											this.$cookies.set(
												window.location.hostname.substring(10, 4) + "_carts",
												response.data.data.cart_session,
												"1y"
											);
											this.$root.cart_session = response.data.data.cart_session;
										}
										this.$root.customer_detail = response.data.data.customer;
										if (response.data.data.address.length) {
											
											this.$root.address = response.data.data.address;
											this.$cookies.set(
												window.location.hostname.substring(10, 4) + "_pin",
												this.$root.address[0].pin_code
											);
											for (let i = 0; i < this.$root.address.length; i++) {
												if (i == 0) {
													this.$root.address_id = this.$root.address[i].id * 1;
													this.$root.select_address_no = i;
												}
											}
										}
										this.$root.back_after_login = false;
										this.$gtm.trackEvent({
											event: "Login",
											category: "Login",
											action: "Login Success",
										});
										this.$gtm.trackEvent({
											event: "Login_status",
											category: "Login_status",
											action: "Login Success",
											Mobile_no: this.$root.customer_detail.phone,
											Email: this.$root.customer_detail.email,
										});
										//this.$router.push(this.from_path);
										this.$root.login_popup = false;
									} else {
										this.$root.success_message = "";
										this.$root.page_loader = false;
										this.$root.error_message = response.data.message;
										this.$root.customer_id = "";
										this.$gtm.trackEvent({
											event: "Login",
											category: "Login",
											action: "Login Failure",
											label: response.data.message,
										});
									}
								})
								.catch((error) => {
									this.$root.page_loader = false;
									if (error.message === "Network Error") {
										this.$root.error_message =
											"Oops there seems to be some Network issue, please try again.";
									}
									window.scrollTo(0, 0);
								});
						} else {
							this.otp = false;
						}
					} else {
						this.otp = false;
						this.otp_error = "Please enter valid OTP";
					}
				},
			},
		},
	};
</script>